export default "__VITE_ASSET__C_NDH6Vp__"